export const REQUEST_OWNER = 'REQUEST_OWNER' as const
export const CREATE_DOCUMENT_REQUEST = 'CREATE_DOCUMENT_REQUEST' as const
